import { Title, Text, Image, Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/main/project');
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <div>
          <Title order={1}>Access denied</Title>
        </div>
        <div className="w-[30%] mx-auto">
          <Image src="/access-denied.png" alt="Random unsplash image" />
        </div>
        <div>
          <Text c="gray">You can't access this resource as it is currently not shared with you.</Text>
          <Button className="mt-4" onClick={() => handleBack()}>
            Back to home
          </Button>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
